import { FC, ReactNode } from "react"
import LinkComponent from "../../atoms/LinkComponent"

type IProps = {
    children: ReactNode,
    to: string
}


const DesktopMenuItem: FC<IProps> = ({ children, to }) => {
    return (
        <LinkComponent to={to}>
            <div className="mx-[24px] my-[12px] text-[14px] font-medium text-[#1a1a1a]">{children}</div>
        </LinkComponent>
    )
}

export default DesktopMenuItem